"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _babelHelperVueJsxMergeProps = _interopRequireDefault(require("@vue/babel-helper-vue-jsx-merge-props"));

var _Header = _interopRequireDefault(require("../Header"));

var _Footers = _interopRequireDefault(require("../Footers"));

var _Aside = _interopRequireDefault(require("../Aside"));

var _Collapse = _interopRequireDefault(require("../Collapse"));

var _TagViews = _interopRequireDefault(require("../TagViews"));

var _utils = require("../utils");

require("./style.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FeLayout = {
  name: 'FeLayout',
  functional: true,
  render: function render(h, context) {
    var asideTitleRender = (0, _utils.getComponentFromProp)(context, 'asideTitle');
    var footerRender = (0, _utils.getComponentFromProp)(context, 'footer');
    var _context$props = context.props,
        isCollapse = _context$props.isCollapse,
        toggleCollapse = _context$props.toggleCollapse,
        showTagViews = _context$props.showTagViews;
    return h("el-container", {
      "class": isCollapse ? 'fe-layout-collapse' : 'fe-layout'
    }, [h("el-header", {
      "attrs": {
        "height": "48px"
      }
    }, [h(_Header.default, (0, _babelHelperVueJsxMergeProps.default)([{}, {
      props: _objectSpread({}, context.props),
      scopedSlots: _objectSpread({}, context.scopedSlots)
    }]))]), h("el-container", [h("el-aside", {
      "class": "el-aside-menu",
      "attrs": {
        "width": "180px"
      }
    }, [h(_Aside.default, {
      "props": _objectSpread({}, _objectSpread({}, context.props))
    }, [asideTitleRender]), h(_Collapse.default, {
      "props": _objectSpread({}, {
        toggleCollapse: toggleCollapse,
        isCollapse: isCollapse
      })
    })]), h("el-container", {
      "class": "main-content"
    }, [h("el-main", [showTagViews ? h(_TagViews.default, {
      "props": _objectSpread({}, _objectSpread({}, context.props))
    }) : null, showTagViews ? h("transition", [h("keep-alive", [h("router-view")])]) : h("router-view")]), h("el-footer", {
      "attrs": {
        "height": "38px"
      }
    }, [h(_Footers.default, [footerRender])])])])]);
  }
};

FeLayout.install = function (Vue) {
  Vue.component(FeLayout.name, FeLayout);
};

var _default = FeLayout;
exports.default = _default;